module.exports = __webpack_public_path__ + "img/footer-graphic-2x.b2cce406.png";